<mat-tab-group class="data-collection-tab">
    <mat-tab label="Drill Data Details">
        <app-drill-data-collection-view [type]="'drillData'"></app-drill-data-collection-view>
    </mat-tab>

    <mat-tab label="Blast Data Details">
        <app-drill-data-collection-view  [type]="'blastData'"></app-drill-data-collection-view>
    </mat-tab>

     <mat-tab label="Fielder Data Details">
        <app-drill-data-collection-view  [type]="'fielderData'"></app-drill-data-collection-view>
    </mat-tab>

    <mat-tab label="Drill Shift Details">
        <app-drill-shift-details-collection-view></app-drill-shift-details-collection-view>
    </mat-tab>
</mat-tab-group>
